import { CapoPlugin } from "/builds/fatec-developpement/copilot/copilot-front/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];